﻿export class BindingInfo {
    constructor(public type: string, public source: string, public target: string, public mode: string, public parameter: string, public ignoreFieldContext: string = 'false') {}
}
